<template>
  <div id="subpage-content">
    <CompanyDrawer />
    <div id="rcol">
      <v-card id="rcol-incard">
        <h1 id="naming">{{ $t("message.NavbarLicenses") }}</h1>
        <div id="about-card">
          <v-col v-for="item in items" :key="item.id" :cols="item.id">
            <v-card id="lic-card">
              <div id="sertif">
                <v-dialog v-model="dialog1" width="900">
                  <template v-slot:activator="{ on }">
                    <img height="200" width="150" v-on="on" :src="getImageUrl(item)" aspect-ratio="1" class="grey lighten-2" />
                  </template>
                  <v-card>
                    <img :src="getImageUrl(item)" />
                  </v-card>
                </v-dialog>
              </div>
              <div id="lic-card-text">
                <div id="incard-title">
                  {{ getItemName(item) }}
                </div>
                <br />
                {{ getItemText(item) }}
              </div>
            </v-card>
          </v-col>
          <!-- <v-card id="lic-card">
            <div id="sertif">
              <v-dialog v-model="dialog1" width="900">
                <template v-slot:activator="{ on }">
                  <v-img
                    height="200"
                    width="150"
                    v-on="on"
                    :src="getImageUrlbyName('Lic1')"
                    aspect-ratio="1"
                    class="grey lighten-2"
                  ></v-img>
                </template>
                <v-card>
                  <v-img :src="getImageUrlbyName('Lic1')"> </v-img>
                </v-card>
              </v-dialog>
            </div>
            <div id="lic-card-text">
              <div id="incard-title">
                {{ $t("message.LicCardTitle1") }}
              </div>
              <br />
              {{ $t("message.LicCardText1") }}
            </div>
          </v-card>
          <v-card id="lic-card">
            <div id="sertif">
              <v-dialog v-model="dialog2" width="900">
                <template v-slot:activator="{ on }">
                  <v-img
                    height="200"
                    width="140"
                    v-on="on"
                    :src="getImageUrlbyName('Lic2')"
                    aspect-ratio="1"
                    class="grey lighten-2"
                  ></v-img>
                </template>
                <v-card>
                  <v-img :src="getImageUrlbyName('Lic2')"> </v-img>
                </v-card>
              </v-dialog>
            </div>
            <div id="lic-card-text">
              <div id="incard-title">
                {{ $t("message.LicCardTitle2") }}
              </div>
              <br />
              {{ $t("message.LicCardText2") }}
            </div>
          </v-card>
          <v-card id="lic-card">
            <div id="sertif">
              <v-dialog v-model="dialog3" width="900">
                <template v-slot:activator="{ on }">
                  <v-img
                    height="200"
                    width="140"
                    v-on="on"
                    :src="getImageUrlbyName('Lic3')"
                    aspect-ratio="1"
                    class="grey lighten-2"
                  ></v-img>
                </template>
                <v-card>
                  <v-img :src="getImageUrlbyName('Lic3')"> </v-img>
                </v-card>
              </v-dialog>
            </div>
            <div id="lic-card-text">
              <div id="incard-title">
                {{ $t("message.LicCardTitle3") }}
              </div>
              <br />
              {{ $t("message.LicCardText3") }}
            </div>
          </v-card>
             -->
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import CompanyDrawer from "../../../views/Navigations/Company/CompanyDrawer";
export default {
  data: () => ({
    openImgModal: false,
    dialog: false,
    items: [],
    // lic1: require("../../../assets/images/lic1.jpg"),
    // lic2: require("../../../assets/images/lic2.jpg"),
    // lic3: require("../../../assets/images/lic3.png"),
    // sert1: require("../../../assets/images/sert1.jpg"),
    // sert2: require("../../../assets/images/sert2.jpg"),
    // sert3: require("../../../assets/images/sert3.jpg"),
    // sert4: require("../../../assets/images/sert4.jpg"),
    // sert5: require("../../../assets/images/sert5.jpg"),
    // sert6: require("../../../assets/images/sert6.jpg"),
    // sert7: require("../../../assets/images/sert7.jpg"),
    // sert8: require("../../../assets/images/sert8.jpg"),
  }),
  created() {
    window.addEventListener("beforeunload", this.handler());
  },
  async mounted() {
    await this.getLicenseblock();
  },

  components: {
    CompanyDrawer,
  },
  methods: {
    async handler() {
      await this.$store.dispatch("getAllLicenseblocks");
      this.items = await this.$store.getters.getLicenseblocks.filter((item) => item.islicense);
    },
    openImg() {
      this.openImgModal = true;
    },
    async getLicenseblock() {
      // await this.$store.dispatch("getAllLicenseblocks");
      this.items = await this.$store.getters.getLicenseblocks.filter((item) => item.islicense);
      // this.items = this.items.sort(
      //   (b, a) => new Date(a.date) - new Date(b.date)
      // );
      // console.log(this.items);
    },
    getImageUrl(item) {
      return "data:image/jpeg;base64," + item.image;
    },
    getItemName(item) {
      if (this.$i18n.locale === "ru") {
        return item.name1;
      } else if (this.$i18n.locale === "gb") {
        return item.name2;
      }
    },
    getItemText(item) {
      if (this.$i18n.locale === "ru") {
        return item.text1;
      } else if (this.$i18n.locale === "gb") {
        return item.text2;
      }
    },
  },
};
</script>
<style>
#lic-card {
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
}
#sertif {
  padding: 10px;
  display: flex;
  align-items: center;
  width: 25%;
}
#lic-card-text {
  width: 75%;
  padding: 15px;
  margin-left: 15px;
  font: 13px/20px Ubuntu, Arial, sans-serif;
}
@media (max-width: 860px) {
  #lic-card {
    height: 450px;
    width: 400px;
    display: flex;
    flex-direction: column;
  }
  #sertif {
    width: 100%;
  }
}
@media (max-width: 480px) {
  #lic-card {
    height: 550px;
    width: 230px;
  }
}
</style>
